export const getErrorMessage = (error: unknown, fallback: string) => {
  if (typeof error === 'string' && error.trim()) return error;
  if (!(error instanceof Error)) return fallback;

  const response = 'response' in error ? error.response : undefined;
  if (typeof response === 'string' && response.trim()) return response;

  return error.message || fallback;
};
